import type { StageParameters } from '../../stage/stage-parameters';

export type GraphQLEndpointEnvSetting = ReturnType<typeof getGraphQLEndpoint>;

export const getGraphQLEndpoint = (
  { baseUrl }: StageParameters,
  { backendApi }: { backendApi: string },
): string => `${baseUrl}${backendApi}/graphql`;
